import { paths } from '@farmersdog/constants';
import { LINK_PRIVACY_OPTOUT } from '@farmersdog/constants/links';
import type { LinkProps } from '@farmersdog/corgi-x';
import { Link, PageWidth, Text } from '@farmersdog/corgi-x';

import styles from './LegalDetails.css';

interface Link {
  label: string;
  props: LinkProps;
}

export const links: Link[] = [
  {
    label: 'Privacy',
    props: {
      href: paths.PATH_PRIVACY,
    },
  },
  {
    label: 'Terms',
    props: {
      href: paths.PATH_TERMS,
    },
  },
  {
    label: 'Do Not Sell My Personal Information',
    props: {
      href: LINK_PRIVACY_OPTOUT,
    },
  },
];

export function LegalDetails() {
  return (
    <PageWidth>
      <div className={styles.container}>
        <div className={styles.copyright}>
          <Text
            className={styles.copyrightText}
            variant="heading-13"
            color="white"
            as="span"
          >
            © {new Date().getFullYear()} The Farmer’s Dog, Inc.
          </Text>
          <Text
            className={styles.longLiveDogs}
            variant="heading-13"
            color="white"
            as="span"
          >
            Long Live Dogs™
          </Text>
        </div>
        <ul aria-label="Legal details" className={styles.legalDetails}>
          {links.map(link => (
            <Text
              key={link.label}
              className={styles.link}
              variant="heading-13"
              as="li"
            >
              <Link baseColor="white" {...link.props}>
                {link.label}
              </Link>
            </Text>
          ))}
        </ul>
      </div>
    </PageWidth>
  );
}
